export const SERVICE_REQUEST_FORM_SUBMISSION_STATUS = {
  IN_PROGRESS: 'IN-PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

export type ServiceRequestFormSubmissionStatus =
  typeof SERVICE_REQUEST_FORM_SUBMISSION_STATUS[keyof typeof SERVICE_REQUEST_FORM_SUBMISSION_STATUS];

export function resolveServiceRequestFormSubmissionStatus(
  complete: boolean,
): ServiceRequestFormSubmissionStatus {
  return complete
    ? SERVICE_REQUEST_FORM_SUBMISSION_STATUS.COMPLETED
    : SERVICE_REQUEST_FORM_SUBMISSION_STATUS.IN_PROGRESS;
}
